import api from "../config/api";

export const fetchGoldRate= async ()=>{
    const res = await api.get(`/goldrate/`)
    return res.data.data;
}

export const createGoldRate= async (goldRateData)=>{
    const res = await api.post(`/goldrate/`,goldRateData)
    return res.data.data;
}

export const updateGoldRate= async(id,goldRateData)=>{
    const res = await api.post(`/goldrate/?id=${id}`,goldRateData)
    return res.data;
}

export const deleteGoldRate= async(id)=>{
    const res = await api.delete(`/goldrate/?id=${id}`)
    return res.data;
}